import {Controller} from "@hotwired/stimulus"
import Cookies from 'js-cookie'

export class FilterController extends Controller {
	static targets = ["districtInput", "districtView", "filterIndicator"]

	connect() {
		this.connected = true
		this.districtViewTargets.forEach(target => {
			let district   = target.dataset.filterDistrict
			let visibility = Cookies.get(`_filter_${district}`)
			if (visibility === undefined) {
				Cookies.set(`_filter_${district}`, "true", {expires: 365})
				visibility = "true"
			}
			this.toggleTarget(target, visibility)
		})
		this.districtInputTargets.forEach(target => {
			let district = target.value
			let checked  = Cookies.get(`_filter_${district}`)
			if (checked === undefined) {
				Cookies.set(`_filter_${district}`, "true", {expires: 365})
				checked = "true"
			}
			target.checked = checked === "true"
		})
		this.toggleFilterIndicator()
	}

	toggleInput({target}) {
		let district  = target.value
		const checked = target.checked.toString()
		Cookies.set(`_filter_${district}`, checked, {expires: 365})
		const view = this.element.querySelectorAll(`[data-filter-district=${district}]`)
		view.forEach(target => this.toggleTarget(target, checked))
		this.toggleFilterIndicator()
	}

	toggleTarget(target, visibility) {
		target.classList.toggle("d-none", visibility !== "true")
	}

	toggleFilterIndicator() {
		const somethingFiltered = this.districtInputTargets.find(target => {
			let district = target.value
			return Cookies.get(`_filter_${district}`) === "false"
		})
		this.filterIndicatorTarget.classList.toggle("d-none", somethingFiltered === undefined)
	}

	districtViewTargetConnected(target) {
		if (this.connected) {
			this.toggleTarget(target)
		} else {
			target.classList.add("d-none")
		}
	}
}